import React, { useMemo } from 'react';
import { Heading, Progress } from '../../../components/core';
import { PageContent, PageTopBar } from '../../../components/page';
import { getRoute, routes, useLocation, useNavigate } from '../../../routes';
import { getStylesheet } from '../../../styles';

const connectNowRoutes = [
  routes.connectNowConfirmInfo[0],
  routes.connectNowPreEncounterForm[0],
] as const;

export const ConnectNowPageWrapper = ({
  children,
  testID,
}: {
  children: JSX.Element;
  testID: string;
}): JSX.Element => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const goBack = (): void => {
    const currentPageIdx = connectNowRoutes.findIndex(route => route === pathname);
    const previousPage = connectNowRoutes[currentPageIdx - 1];

    if (previousPage !== undefined) {
      navigate(previousPage, {});
    }
  };

  const goHome = (): void => {
    navigate(getRoute('connectNowHome', {}));
  };

  const getProgress = useMemo(() => {
    const currentPageIdx = connectNowRoutes.findIndex(route => route === pathname);
    return ((currentPageIdx + 1) / connectNowRoutes.length) * 100;
  }, [pathname]);

  return (
    <PageContent testID={testID} padding={1}>
      <PageTopBar
        backAccessibilityLabel="Back to ConnectNow Home"
        onBackPress={goBack}
        onClosePress={goHome}
      >
        <Heading.h5 center paddingY={3}>
          ConnectNow: Video
        </Heading.h5>
      </PageTopBar>

      <Progress
        {...styles.progress}
        accessibilityLabel="ConnectNow progress"
        variant="skill"
        value={getProgress}
      />

      {children}
    </PageContent>
  );
};

const styles = getStylesheet({
  progress: {
    width: '70%',
    alignSelf: 'center',
    marginBottom: 4,
  },
});
